export default {
   getUrlParam(name) {
    return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null
  },
  getParams(field) {
    let url = window.location.href,
      param = {},
      splitArray = url.split("?"),
      searchLocation = splitArray.length <= 1 ? "" : splitArray[1].split("#")[0],
      searchParams = searchLocation
.split("&"),
      value,
      key;
    for (var i = 0, leni = searchParams.length; i < leni; i++) {
      key = searchParams[i].split("=")[0];
      value = searchParams[i].split("=")[1];
      if (!key) {
        continue;
      }
      param[key] = value;
    }

    // 路由跳转时url参数会被覆盖,所以仅在首次进入时读取
    return field ? param[field] : param;
  },
  isCode(code) {
    // let reg = /^[A-Za-z0-9]{6}$/
    let reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6}$/

    return reg.test(code)
  },
  isNum(code){
    let reg =  /^[0-9]+$/
    return reg.test(code)
  },
  moneyToFixed(n) {
    let num = new Number(n)

    return num.toFixed(2)
  },
  isCardNo(card){
    // 身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X  
    var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;  
    if(reg.test(card) === false){  
        // alert("身份证输入不合法");  
        return  false;  
    }
    return true
  },
  isName(name){
    // 是否是汉字
    let regName =/^[\u4e00-\u9fa5]{2,6}$/;  
    if(!regName.test(name)){  
        // alert('真实姓名填写有误');  
        return false;  
    }

    return true
  },
  handleinput2(row){
    row.inputvalue=row.inputvalue.replace(/[^0-9.]/g, '')
  },
  isPhone(phone) {
    // var pattern = /(^1[3|4|5|7|8]\d{9}$)|(^0\d{2,3}\d{8}$)/;
    let pattern = /^((13[0-9])|(145)|(147)|(15[0-3])|(15[5-9])|(17[0-9])|(18[0-9])|(190)|(191)|(192)|(193)|(195)|(196)|(199)|(198)|(166))\d{8}$/;
  
    var isright = pattern.test(phone);
    return isright;
  },
  trimAll(txt) {
  	//去掉所有空格
    return txt && txt.replace(/\s+/g, "");
  },
  formatter (thistime, fmt) {
    let $this = new Date(thistime)
    let o = {
      'M+': $this.getMonth() + 1,
      'd+': $this.getDate(),
      'h+': $this.getHours(),
      'm+': $this.getMinutes(),
      's+': $this.getSeconds(),
      'q+': Math.floor(($this.getMonth() + 3) / 3),
      'S': $this.getMilliseconds()
    }
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, ($this.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
    for (var k in o) {
      if (new RegExp('(' + k + ')').test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
      }
    }
    return fmt
  }
}



// WEBPACK FOOTER //
// ./src/utils/util.js